mutation AddPlusOne(
  $attendeeId: ID!
  $plusOne: AttendeeDetailsInput!
  $notify: Boolean
) {
  addPlusOne(
    input: { attendeeId: $attendeeId, plusOne: $plusOne, notify: $notify }
  ) {
    plusOne {
      id
      status
    }
  }
}
